
<div class="data-table">
    <b-table
        v-bind="$attrs"
        v-on="$listeners"
        :per-page="currentPerPage"
        :current-page="currentPage"

        ref="data_table"
    >
        <template #table-busy>
            <Loader />
        </template>

        <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
        <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData"
            ><slot :name="name" v-bind="slotData"
        /></template>
    </b-table>

    <div v-if="enableTotalRows && totalRows > 0 && showRichTable" class="total-rows text-muted mb-2 text-left">
        {{ $tc("table.pagination.total", totalRows, [totalRows]) }}
    </div>
    <div v-if="enablePagination && totalRows > minPerPage && showRichTable" class="text-left">
        <div class="d-inline-block">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="currentPerPage"
                class="mb-0"
            ></b-pagination>
        </div>

        <label class="mx-2">{{ $t("table.pagination.label") }}</label>

        <div class="d-inline-block">
            <b-form-select v-model="currentPerPage" :options="pageOptions"></b-form-select>
        </div>
    </div>
</div>
